import React from "react";
import Loader from "../shared/Loader";

const PaymentButton = ({ text, onClick, type, isPending }) => {
  return (
    <button disabled={isPending} onClick={onClick} type={type} class="group relative w-full disabled:cursor-not-allowed  ">
      <div class="relative overflow-hidden rounded-xl bg-dark p-[1px] shadow-2xl shadow-emerald-500/20">
        <p className="px-6 py-2 text-[18px] text-white font-semibold  ">
          {isPending ? (
            <div className="w-8 h-full mx-auto">
              <Loader />
            </div>
          ) : (
            text
          )}
        </p>

        <div class="absolute  inset-0 rounded-xl bg-gradient-to-br from-emerald-400 via-emerald-500 to-emerald-600 opacity-10 transition-opacity duration-300 group-hover:opacity-40"></div>
      </div>
    </button>
  );
};

export default PaymentButton;
